import { render } from "./Quietanza.vue?vue&type=template&id=0fd21290&scoped=true"
import script from "./Quietanza.vue?vue&type=script&lang=js"
export * from "./Quietanza.vue?vue&type=script&lang=js"

import "./Quietanza.vue?vue&type=style&index=0&id=0fd21290&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd21290"]])

export default __exports__